'use client'
import React from 'react'
import { useRouter } from 'lib/next-intl'
import { useTranslations } from 'next-intl'

const TrendingCommunityHeader = () => {
  const router = useRouter()
  const t = useTranslations()
  return (
    <div className='relative flex justify-center items-center px-4 h-12'>
      <div
        className='i-ps-chevron_left [--icon-size:24px] absolute left-[16px] cursor-pointer'
        onClick={() => {
          router.back()
        }}
      />
      <p className='text-header text-label-l1'>
        {t('search.trending_communities')}
      </p>
    </div>
  )
}

export default TrendingCommunityHeader
